<template>
  <div>
    <div class="isis-modal-header">
      <h3 class="title">{{ $t("student.communication_detail") }}</h3>
      <div>
        <button
          v-if="!isEdit && isEditCommunicationLog"
          class="close-btn mr-5"
          @click.prevent="isEdit = !isEdit"
        >
          <i class="fas fa-edit edit-icon"></i>
        </button>
        <button
          v-if="isEdit"
          class="close-btn mr-5"
          @click.prevent="isEdit = !isEdit"
        >
          <i class="fas fa-eye view-icon"></i>
        </button>
        <button class="close-btn" @click="$modal.hide(modalName)">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <validation-form @on-submit="editCommunication" class="validation-form">
      <div class="form-input mb-10">
        <div class="md-layout mt-15">
          <div class="md-layout-item md-size-50 pt-3">
            <span class="font-normal"
              >{{ $t("class.staff_in_contact") }}:
            </span>
            <span>{{ form.staff_in_contact }}</span>
          </div>
          <div class="md-layout-item md-size-50 pt-3">
            <span class="font-normal">{{ $t("class.date_of_contact") }} :</span>
            <span>{{ form.date_of_contact }}</span>
          </div>
          <div class="md-layout-item md-size-50 pt-3 method-contact">
            <md-field>
              <label :for="selectMethod.name">{{
                $t(selectMethod.label)
              }}</label>
              <md-select
                :disabled="!isEdit"
                :id="selectMethod.name"
                v-model="form.method"
                :multiple="selectMethod.multiple"
              >
                <md-option
                  v-for="option in selectMethod.options"
                  :value="option.id"
                  :key="option.id + option.name"
                  >{{ $t(option.name) }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50 pt-3">
            <template class="pt-10">
              <label class="label-checkbox font-normal">{{
                $t("student.concerns")
              }}</label>
              <checkbox-multi-select
                :isDisabled="!isEdit"
                :key="componenKey"
                :options="concernSelect.options"
                :trackBy="concernSelect.trackBy"
                :displayField="concernSelect.displayField"
                v-model="form.concerns"
                :style="{ marginTop: '-6px' }"
              >
              </checkbox-multi-select>
            </template>
          </div>
          <div v-if="isEdit" class="md-layout-item md-size-100 pt-3">
            <label class="font-normal"
              >{{ $t("student.communication_detail") }}
            </label>
            <validation-field
              class="border border-gray-300 p-2"
              :validations="communication_validation.communicationDetail"
              name="Communication log"
              isTextArea="true"
            >
              <md-textarea
                class="p-0"
                v-model="form.communication_detail"
              ></md-textarea>
              <span
                class="md-error-server"
                v-if="serverValidations.communication_detail"
              >
                {{ serverValidations.communication_detail }}
              </span>
            </validation-field>
          </div>
          <div v-if="isEdit" class="md-layout-item md-size-100 pt-10 ">
            <label class="font-normal">
              {{ $t("class.response_from_parent") }}</label
            >
            <validation-field
              class="border border-gray-300 p-2"
              :validations="communication_validation.communicationDetail"
              name="Response from parent"
              isTextArea="true"
            >
              <md-textarea
                class="p-0"
                v-model="form.response_from_parent"
              ></md-textarea>
              <span
                class="md-error"
                v-if="serverValidations.response_from_parent"
              >
                {{ serverValidations.response_from_parent }}
              </span>
            </validation-field>
          </div>
          <div v-if="!isEdit" class="md-layout-item md-size-100 pt-3">
            <span class="font-normal"
              >{{ $t("student.communication_detail") }}:
            </span>
            <span class="break-words">{{ form.communication_detail }} </span>
          </div>
          <div v-if="!isEdit" class="md-layout-item md-size-100 pt-3">
            <span class="font-normal">
              {{ $t("class.response_from_parent") }}:
            </span>
            <span class="break-words">{{ form.response_from_parent }} </span>
          </div>
        </div>
      </div>
      <!-- btn -->
      <div class="form-actions text-right pt-3">
        <md-button class="md-raised" @click="$modal.hide(modalName)">{{
          $t("common.cancel")
        }}</md-button>
        <md-button v-if="isEdit" type="submit" class="md-success ml-4">{{
          $t("common.update")
        }}</md-button>
      </div>
    </validation-form>
  </div>
</template>
<script>
import TableActions from "./TableActions";
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import { parameterValidations } from "@/validations/classes";
import { getId, Message } from "@/helpers/utils";
import { service_names } from "@/constants/Services";
import pick from "lodash/pick";
import { methodOption } from "./ultils";
import { Student } from "@/constants/Permissions";
import moment from "moment";
export default {
  props: ["data", "modalName"],
  components: { CheckboxMultiSelect },
  data() {
    return {
      isEdit: false,
      modalData: null,
      TableActions,
      communication_validation: parameterValidations,
      serverValidations: "",
      form: this.data,
      componenKey: 1,
      selectMethod: {
        label: "student.method",
        name: "method__",
        value: "",
        type: "select",
        options: methodOption
      }
    };
  },
  watch: {
    isEdit: function() {
      this.componenKey++;
    }
  },
  computed: {
    isEditCommunicationLog() {
      return this.$can(Student.actions.editCommunicationLog, Student.subject);
    },
    concernSelect() {
      return {
        label: "select",
        name: "subject",
        value: [],
        type: "checkbox-multi-select",
        options: [
          {
            id: "Academic",
            name: this.$t("student.academic")
          },
          {
            id: "Behavior",
            name: this.$t("student.behavior")
          },
          {
            id: "Attendance",
            name: this.$t("student.attendance")
          },
          {
            id: "Homework",
            name: this.$t("student.homework")
          },
          {
            id: "Academic-performance",
            name: this.$t("student.academic_performance")
          },
          {
            id: "Extracurricular",
            name: this.$t("student.extracurricular")
          },
          {
            id: "Students_account",
            name: this.$t("student.students_account")
          },
          {
            id: "Parents Feedback",
            name: this.$t("student.parents_feedback")
          },
          {
            id: "Others",
            name: this.$t("student.others")
          }
        ],
        trackBy: "id",
        displayField: "name"
      };
    }
  },
  methods: {
    editCommunication() {
      const form = pick(this.form, [
        "communication_detail",
        "response_from_parent",
        "method",
        "concerns",
        "date_of_contact"
      ]);
      form.date_of_contact = moment(form.date_of_contact, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      const communicationLogId = getId(this.data);
      this.$axios
        .put(
          `${service_names.school}/communication-log/${communicationLogId}`,
          form
        )
        .then(() => {
          Message.success(this.$t("common.success"));
          this.$emit("refetchTableData");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.validation-form {
  .form-actions {
    border-top: 0.5px solid #aaa;
  }
  .label-checkbox {
    font-size: 11px;
    color: #aaaaaa !important;
    padding-bottom: 3px;
  }
  .method-contact {
    div {
      top: 4px !important;
    }
  }
  .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
    min-height: 100px;
    max-height: 150px;
    padding: 0 16px;
    resize: none;
  }
}
.isis-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    padding: 0;
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
  button.close-btn {
    padding: 5px 8px;
    border: none;
    background-color: transparent;
    transition: 0.15s;
    cursor: pointer;
    border-radius: 3px;

    &:focus {
      outline: none;
      border: none;
    }

    &:hover {
      background-color: rgba(gray, 0.4);
    }

    i {
      font-size: 16px;
      color: gray;
    }
    i.edit-icon {
      color: green;
    }
    i.view-icon {
      color: #ff9800;
    }
  }
}
</style>
